import React from 'react';
import WelcomeContainer from 'features/Welcome';
import { PropTypes } from 'prop-types';
import { useParams } from "react-router-dom";

const WelcomePage = () => {
	const { custId } = useParams();	
 	return <WelcomeContainer custId={custId} />;
}

WelcomePage.propTypes = {
	match: PropTypes.shape({}),
};
WelcomePage.defaultProps = {
	match: {},
};

export default WelcomePage;
